function addString(into, toAdd) {
    if (toAdd === null) {
        return into;
    }
    else if (into === null) {
        return toAdd;
    }
    else if (Array.isArray(into)) {
        if (Array.isArray(toAdd)) {
            return into.concat(toAdd);
        }
        else {
            into.push(toAdd);
            return into;
        }
    }
    else {
        if (Array.isArray(toAdd)) {
            return [into].concat(toAdd);
        }
        else {
            return [into, toAdd];
        }
    }
}
function toSingleString(strings) {
    if (strings == null) {
        return null;
    }
    else {
        return (Array.isArray(strings)) ?
            strings.join("\n") :
            strings;
    }
}
function toArrayOfStrings(strings) {
    if (strings == null) {
        return [];
    }
    else {
        return (Array.isArray(strings)) ?
            strings :
            [strings];
    }
}
export { addString, toSingleString, toArrayOfStrings, };
